import type { ComponentType, LazyExoticComponent } from 'react';
import { lazy } from 'react';

import type { A11y, LoaderImageType } from '@snowit/icetypes';

type LoaderProps = { a11y?: A11y };
type LoaderImport = () => Promise<{ default: ComponentType<LoaderProps> }>;

/** I 12 loader sono ~50kb brotli, ma un tenant ne puo' raggiungere solo 1-3
 * (vedi loadingIllustration in modules/utilities/useUtilities). Importarli
 * staticamente li metteva tutti nel bundle iniziale, quindi qui restano dietro
 * a un import dinamico e il set del tenant viene scaldato con preload(). */
const imports: Record<LoaderImageType, LoaderImport> = {
  bike: () => import('./BikeLoader'),
  bus: () => import('./BusLoader'),
  cabins: () => import('./CabinsLoader'),
  cartAdd: () => import('./CartLoader'),
  cervino: () => import('./CervinoSkiLoader'),
  ferry: () => import('./FerryLoader'),
  gears: () => import('./GearsLoader'),
  hotelSearch: () => import('./HotelSearchLoader'),
  jeep: () => import('./JeepLoader'),
  kitesurf: () => import('./KitesurfLoader'),
  snowcat: () => import('./SnowcatLoader'),
  train: () => import('./TrainLoader'),
};

const components = {} as Record<LoaderImageType, LazyExoticComponent<ComponentType<LoaderProps>>>;
for (const key of Object.keys(imports) as LoaderImageType[]) {
  components[key] = lazy(imports[key]);
}

export const loaderComponents = components;

/** Avvia il download del chunk senza renderizzare, cosi' quando il loader serve
 * davvero e' gia' in cache e non si vede il placeholder vuoto. Idempotente:
 * useUtilities e' un hook, non un provider, quindi gira in molti componenti. */
const started = new Set<LoaderImageType>();
export const preloadLoaderImages = (imgs: LoaderImageType[]): void => {
  for (const img of imgs) {
    if (started.has(img) || !imports[img]) continue;
    started.add(img);
    // un preload fallito non deve rompere nulla: al render ci pensa Suspense
    void imports[img]().catch(() => started.delete(img));
  }
};
